
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment/app/success",
      function () {
        return require("private-next-pages/payment/app/success.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payment/app/success"])
      });
    }
  